import React from 'react'
import ConfirmForm from '../confirm-form/confirm-form'

const Confirm = () => {
  return <ConfirmForm />
}

export default Confirm